import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fireStore } from '../../firebaseConfig';
import { collection, getDocs,Timestamp } from 'firebase/firestore';

const Report = () => {
  const [appraisals, setAppraisals] = useState([]);

 
  useEffect(() => {
    const fetchAppraisals = async () => {
      try {
        const collectionRef = collection(fireStore, 'Appraisals');
        const querySnapshot = await getDocs(collectionRef);
  
        // Map through the query snapshot, convert doc ID to timestamp, and sort by timestamp
        const appraisalsList = querySnapshot.docs
          .map(doc => {
            const idAsTimestamp = Timestamp.fromDate(new Date(parseInt(doc.id.substring(0, 8), 16) * 1000));
            return { id: doc.id, timestamp: idAsTimestamp, ...doc.data() };
          })
          .sort((a, b) => b.timestamp - a.timestamp); // Sort in descending order by timestamp
  
        setAppraisals(appraisalsList);
  
        // Alerting the first appraisedName if there is data
        if (appraisalsList.length > 0) {
          console.log(`First Appraisal: ${appraisalsList[0].appraisedName}`); // Replace 'appraisedName' with the relevant field
        }
      } catch (error) {
        console.error('Error fetching appraisals:', error);
      }
    };
  
    fetchAppraisals();
  }, []);


  return (
    <div className="p-8 bg-lightgray">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <h2 className="text-2xl font-semibold mb-4 md:mb-0 font-lato">Review Reports</h2>
        <div className="space-x-4 hidden">
          <div className='flex items-center'>
            <label htmlFor="from-date" className="mr-2 font-lato">From Date</label>
            <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 13L0.138786 0.249999L14.8612 0.25L7.5 13Z" fill="#056886"/>
            </svg>
          </div>
          <div className='flex items-center'>
            <label htmlFor="to-date" className="mr-2 font-lato">To Date</label>
            <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 13L0.138786 0.249999L14.8612 0.25L7.5 13Z" fill="#056886"/>
            </svg>
          </div>
        </div>
      </div>

      <div className="container mx-auto bg-white p-4 mt-2 rounded-lg shadow-lg h-full overflow-y-scroll">
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border">
            <thead>
              <tr className="uppercase text-sm leading-normal">
                <th className="py-3 px-6 text-left font-lato font-bold text-liquidblue font-2xl">Name</th>
                <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">Designation</th>
                <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">User Name</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 text-sm font-light">
              {appraisals.map(item => (
                <tr key={item.id} className="border-b border-gray-200 hover:bg-gray-100 shadow-xl">
                  <td className="py-3 px-6 text-left whitespace-nowrap font-lato font-bold text-black">{item.appraisedName}</td>
                  <td className="py-3 px-6 text-center font-lato font-bold text-black">{item.designation}</td>
                  <td className="py-3 px-6 text-center font-lato font-bold text-black">{item.user?.name}</td>
                  <td className="py-3 px-6 text-center">
                    <button className="bg-darkteal text-white px-4 py-2 rounded-lg font-lato font-bold">
                      <Link to={`/reports/show/${item.id}`} className='font-lato'>Show</Link>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Report;
